<!-- Header Actions -->
<div class="row">
  <div class="col" [ngClass]="{ invisible: currentTabId !== 'general' }">
    <div id="header-actions" class="d-flex align-items-end justify-content-end">
      <button class="btn btn-outline-primary" (click)="handleCancel()">Cancel</button>
      <button class="btn btn-primary" *ngIf="isAllowed('tool_models', 'edit')" (click)="handleSave(false)">Save</button>
      <button class="btn btn-primary" *ngIf="isAllowed('tool_models', 'edit')" (click)="handleSave(true)">
        Save & Close
      </button>
    </div>
  </div>
</div>
<!-- End Header Actions -->

<form name="form" #toolModelForm="ngForm" novalidate (keydown.enter)="$event.preventDefault()">
  <div class="row">
    <div class="col">
      <app-nav-tabs [tabs]="tabs" (onClick)="handleTabClick($event)">
        <div id="tab-content" class="tab-content body-content-scroll scrollbar">
          <div id="general" class="tab-pane fade show active" role="tabpanel" aria-labelledby="general-tab">
            <app-card>
              <span class="header">Model Details</span>
              <div class="row">
                <div class="col-6">
                  <div class="form-row">
                    <!--- Model Image -->
                    <div class="col-2">
                      <div class="form-group">
                        <label>Model Image</label>
                        <ng-container>
                          <div
                            style="
                              display: flex;
                              align-items: center;
                              justify-content: center;
                              border: 1px solid gray;
                              border-radius: 5px;
                            ">
                            <ng-container *ngIf="hasImage()">
                              <div class="thumbnail">
                                <div class="attachment-block">
                                  <img [src]="getImageLink()" />
                                  <div class="thumbnail-delete">
                                    <a (click)="handleDelete(dataModel?.thumbnail[0]?.media?.id, 'thumbnail')"
                                      ><i class="fa fa-times"></i
                                    ></a>
                                  </div>
                                </div>
                              </div>
                            </ng-container>
                            <ng-container *ngIf="!hasImage()">
                              <input
                                hidden
                                type="file"
                                #imageUploader
                                accept="image/*"
                                (change)="handleUploadThumbnail($event, 'thumbnail', 'tool_models')" />
                              <a id="uploadImageLink" (click)="imageUploader.click()">Upload</a>
                            </ng-container>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                    <!-- End Model Image -->

                    <!-- Model Name, Asset Class, Manufacturer, and Category -->
                    <div class="col">
                      <div class="form-row">
                        <div class="form-group form-group-inline col-6">
                          <!-- Changed Model title field to Description per request of Client -->
                          <label for="modelName">Description</label>
                          <input
                            id="modelName"
                            type="text"
                            class="form-control"
                            placeholder="Enter model name"
                            #name="ngModel"
                            name="name"
                            required
                            minlength="1"
                            ngControl="name"
                            required
                            [(ngModel)]="payloadModel.name" />
                          <div *ngIf="submitted && toolModelForm.controls.name.errors?.required" class="error">
                            Model Name is required.
                          </div>
                        </div>
                        <div class="form-group col-6">
                          <label for="assetClass">Asset Class</label>
                          <select
                            (change)="fetchCategoriesByAssetClass()"
                            id="assetClassId"
                            name="assetClassId"
                            required
                            minlength="1"
                            class="form-control"
                            [(ngModel)]="dataModel.assetClassId">
                            <option *ngFor="let assetClass of assetClasses" [value]="assetClass.id">
                              {{ assetClass.name }}
                            </option>
                          </select>
                          <div
                            *ngIf="submitted && toolModelForm.controls.assetClassId.status === 'INVALID'"
                            class="error">
                            Asset Class is required
                          </div>
                        </div>

                        <div class="form-group form-group-inline col-6">
                          <label for="manufacturer">Manufacturer</label>
                          <select
                            id="tool-search-input"
                            class="form-control"
                            name="manufacturerId"
                            required
                            minlength="1"
                            [(ngModel)]="payloadModel.manufacturerId">
                            <option *ngFor="let manufacturer of manufacturers" [value]="manufacturer.id">
                              {{ manufacturer.name }}
                            </option>
                          </select>
                          <div
                            *ngIf="submitted && toolModelForm.controls.manufacturerId.status === 'INVALID'"
                            class="error">
                            Manufacture is required
                          </div>
                        </div>

                        <div class="form-group form-group-inline col-6">
                          <label for="category">Category</label>
                          <select
                            id="tool-search-input"
                            class="form-control"
                            name="categoryId"
                            [customMin]="1"
                            required
                            minlength="1"
                            #categoryId="ngModel"
                            [(ngModel)]="payloadModel.categoryId">
                            <option [value]="0" [selected]="!payloadModel.categoryId">Select category</option>
                            <option *ngFor="let category of categories" [value]="category.id">
                              {{ category.name }}
                            </option>
                          </select>
                          <div
                            *ngIf="submitted && toolModelForm.controls.categoryId.status === 'INVALID'"
                            class="error">
                            Category is required
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-12">
                            <div class="custom-control custom-checkbox mb-2">
                              <input
                                class="custom-control-input"
                                [(ngModel)]="payloadModel.allowVehicleDetails"
                                type="checkbox"
                                id="inlineCheckbox"
                                name="inlineCheckbox" />
                              <label class="custom-control-label" for="inlineCheckbox">Vehicle Model</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- End Model Name, Asset Class, Manufacturer, and Category -->
                  </div>
                </div>

                <div class="col-6">
                  <div class="row">
                    <!-- Description - Changed Description title to Model per request of Client-->
                    <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 d-flex flex-column">
                      <div class="form-group flex-grow-1 d-flex flex-column">
                        <label for="description">Model</label>
                        <textarea
                          id="description"
                          class="form-control flex-grow-1"
                          type="text"
                          name="description"
                          placeholder="Enter description"
                          rows="4"
                          required
                          #description="ngModel"
                          [disabled]="!isAllowed('tool_models', 'edit')"
                          [(ngModel)]="payloadModel.description"></textarea>
                        <div *ngIf="submitted && toolModelForm.controls.description.status === 'INVALID'" class="error">
                          Description is required
                        </div>
                      </div>
                    </div>
                    <!--- End Description -->

                    <!-- Notes -->
                    <div class="form-group form-group-inline col-6">
                      <label for="notes">Notes</label>
                      <textarea
                        id="notes"
                        class="form-control"
                        type="text"
                        name="notes"
                        placeholder="Enter general notes"
                        rows="4"
                        [disabled]="!isAllowed('tool_models', 'edit')"
                        [(ngModel)]="payloadModel.notes"></textarea>
                    </div>
                    <!-- End Notes -->
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-6">
                  <div class="row">
                    <!-- Weekly Maintenance -->
                    <div class="col-6">
                      <app-service-prompt
                        id="servicePromptMaint"
                        name="maintenanceData"
                        label="Does this model require weekly maintenance?"
                        [serviceInfo]="maintenanceData"
                        [datePrompt]="false"
                        [attachmentData]="dataModel.maintenance"
                        (upload)="handleUploadThumbnail($event, 'maintenance', 'tool_models')"
                        (update)="updatePayload('maintenanceRequired', $event)"
                        [required]="payloadModel.maintenanceRequired"
                        (delete)="handleDelete($event, 'maintenance')">
                        ></app-service-prompt
                      >
                    </div>
                    <!-- End Weekly Maintenance -->

                    <!-- Annual Inspection -->
                    <div class="col-6">
                      <app-service-prompt
                        id="servicePromptInspect"
                        name="inspectionData"
                        label="Does this model require annual inspection?"
                        [serviceInfo]="inspectionData"
                        [datePrompt]="false"
                        [attachmentData]="dataModel.inspection"
                        [required]="payloadModel.inspectionRequired"
                        (upload)="handleUploadThumbnail($event, 'inspection', 'tool_models')"
                        (update)="updatePayload('inspectionRequired', $event)"
                        (delete)="handleDelete($event, 'inspection')"></app-service-prompt>
                    </div>
                    <!-- End Annual Inspection -->
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-row">
                    <!-- Model Year -->
                    <div class="form-group form-group-inline col-4">
                      <label for="modelYear">Model Year</label>
                      <input
                        id="modelYear"
                        class="form-control"
                        type="text"
                        minlength="4"
                        maxlength="4"
                        name="modelYear"
                        (keypress)="numberOnly($event)"
                        [disabled]="!isAllowed('tool_models', 'edit')"
                        [(ngModel)]="payloadModel.modelYear" />
                    </div>
                    <div *ngIf="submitted && toolModelForm.controls.modelYear.status === 'INVALID'" class="error">
                      Year is invalid
                    </div>

                    <!-- End Model Year -->
                  </div>
                </div>
              </div>
            </app-card>

            <div class="row">
              <div class="col-7">
                <!-- Rental Details -->
                <app-tool-rental-details
                  [dataModel]="payloadModel"
                  [disabled]="!isAllowed('tool_models', 'edit')"
                  [formattedValue]="payloadModel"></app-tool-rental-details>
                <!-- End Rental Details -->
              </div>
            </div>
            <div class="row">
              <div class="col-7">
                <!-- Images -->
                <app-attachments-card
                  label="Images"
                  key="images"
                  attachmentType="image"
                  [source]="dataType"
                  parentType="tool_models"
                  [allowChanges]="isAllowed('tool_models', 'edit')"
                  [parentId]="dataModel.id"
                  [attachments]="dataModel.images"
                  (uploadAction)="handleUploadAttachment($event)"
                  (deleteAction)="handleDeleteAttachment($event)"></app-attachments-card>
                <!-- End Images -->
              </div>
              <div class="col-5">
                <app-attachments-card
                  label="Documents"
                  key="documents"
                  attachmentType="document"
                  [source]="dataType"
                  parentType="tool_models"
                  [allowChanges]="isAllowed('tool_models', 'edit')"
                  [parentId]="dataModel.id"
                  [attachments]="dataModel.documents"
                  (uploadAction)="handleUploadAttachment($event)"
                  (deleteAction)="handleDeleteAttachment($event)"></app-attachments-card>
              </div>
            </div>

            <!-- Tools -->
            <app-card *ngIf="payloadModel.status === 'Published'">
              <span class="header d-flex justify-content-between"
                >Tools
                <button class="btn btn-primary" style="width: 150px" (click)="handleAddTool()">Add Tool</button>
              </span>
              <app-tool-list
                [tableData]="toolsTableData"
                [data]="dataModel.tools"
                dataType="tools"
                source="models"
                [modelId]="dataModel.id"></app-tool-list>
            </app-card>
            <!-- End Tools -->
          </div>
        </div>
      </app-nav-tabs>
    </div>
  </div>

  <!-- Footer Actions -->
  <div class="row mb-4 mt-4" [ngClass]="{ invisible: currentTabId !== 'general' }">
    <div class="col">
      <div id="header-actions" class="d-flex align-items-end justify-content-end">
        <button class="btn btn-outline-primary" (click)="handleCancel()">Cancel</button>
        <button *ngIf="isAllowed('tool_models', 'edit')" (click)="handleSave(false)" class="btn btn-primary">
          Save
        </button>
        <button class="btn btn-primary" *ngIf="isAllowed('tool_models', 'edit')" (click)="handleSave(true)">
          Save & Close
        </button>
      </div>
    </div>
  </div>
  <!-- End Footer Actions -->
</form>

<!-- model dialog prompt -->
<app-dialog id="delete-model-dialog">
  <div class="dialog-header d-flex justify-content-between">
    <h5 class="modal-title">{{ dialogRecord.actionName }} {{ dialogRecord?.data?.toolId }}</h5>
  </div>
  <span class="dialog-body">
    <span *ngIf="dialogRecord.actionType === 'delete'">
      Are you sure you want to {{ dialogRecord.actionName | lowercase }} this <b>{{ dialogRecord?.name }}</b
      >?
    </span>
  </span>
  <span class="dialog-footer">
    <button class="btn btn-outline-primary" data-dismiss="modal" (click)="handleCancel(true)">Cancel</button>
    <button type="button" class="btn btn-primary" id="delete-model-dialog_btn-ok">Continue</button>
  </span>
</app-dialog>

<app-tool-transfer></app-tool-transfer>
